(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["related-products"]) return;
  try {
    
  var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'product-recommendations'
  var productRecommendationsSection = document.querySelector(".product-recommendations");
  if (productRecommendationsSection === null) { return; }
  // Read product id from data attribute
  var productId = productRecommendationsSection.dataset.productId;
  // Read base URL from data attribute
  var baseUrl = productRecommendationsSection.dataset.baseUrl;
  // Read limit from data attribute
  var limit = productRecommendationsSection.dataset.limit;
  // Build request URL
  var requestUrl = baseUrl + "?section_id=related-products&product_id=" + productId + "&limit=" + limit;

  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", requestUrl);
  request.onload = function() {
  if (request.status >= 200 && request.status < 300) {
  var container = document.createElement("div");
  container.innerHTML = request.response;
  var slides = container.querySelectorAll('.products-list__slide');

  if (slides.length !== 0 && slides.length !== undefined) {
  productRecommendationsSection.parentElement.innerHTML = container.querySelector(".product-recommendations").innerHTML;

  // reload flickity
  ProjectApp.modules.FlickitySliders.instances.forEach(slider => {
  if (slider.container.classList.contains('products-list__slider')) {
  slider.flickity.reloadCells();
  slider.flickity.resize();
  ProjectApp.helpers.Effects.constructor();
  try  {
  ProjectApp.modules.FlickitySliders.instances[0].flickity.isDraggable = true
  } catch (e) {}
  }
  });
  } else {
  productRecommendationsSection.closest('.products-list--related').remove();
  }
  }
  };
  request.send();
  };

  // Listen for changes done in the Theme Editor
  document.addEventListener("shopify:section:load", function(event) {
  if (event.detail.sectionId === "product-recommendations") {
  loadProductRecommendationsIntoSection();
  }
  });
  // Fetching the recommendations on page load
  loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
